import { createStructuredSelector, createSelector } from 'reselect';

export const batteryAbove = (state) => state.dashboard.batteryAbove; // batterycyclecountcycleCount500
export const batteriesProperties = (state) => state.user?.subscription?.batteriesProperties || [];
export const batteryListCount = createSelector(
  [batteryAbove, batteriesProperties],
  (avgBatHp, properties) => {
    const batteryList = avgBatHp.getIn(['batteryList'], []);
    
    if (!properties || properties.length === 0) {
      return batteryList.filter(
        (value) =>
          value.batteryPercentage >= 50 &&
          value.cycleCount <= 500 &&
          (value.batteryAge === null || value.batteryAge === undefined || value.batteryAge <= 30)
      ).length;
    }
    
    return batteryList.filter(value => {
      let shouldInclude = true;
      
      if (properties.includes('batteryPercentage')) {
        shouldInclude = shouldInclude && value.batteryPercentage >= 50;
      }
      
      if (properties.includes('cycleCount')) {
        shouldInclude = shouldInclude && value.cycleCount <= 500;
      }
      
      if (properties.includes('batteryAge')) {
        shouldInclude = shouldInclude && (value.batteryAge === null || value.batteryAge === undefined || value.batteryAge <= 30);
      }
      
      return shouldInclude;
    }).length;
  }
);

export const alertTag = createSelector([batteryListCount], (avgBatHp) => (avgBatHp > 0 ? 'alert' : ''));

export const previousMonth = createSelector([batteryAbove], (avgBatHp) => avgBatHp.getIn(['previousMonth'], 0));

export const timeStamp = createSelector([batteryAbove], (avgBatHp) => avgBatHp.getIn(['timeStamp'], ''));

export const statusCode = createSelector([batteryAbove], (statusCode) => statusCode.getIn(['statusCode'], undefined));

export const loading = createSelector([batteryAbove], (avgBatHp) => avgBatHp.getIn(['loading'], false));

export const avgBatteryCycleCard = (state) => state.dashboard.batteryAbove;
export const data = createSelector(
  [avgBatteryCycleCard, batteriesProperties], 
  (avgBatHp, properties) => {
    const batteryList = avgBatHp.getIn(['batteryList'], []);
    
    if (!properties || properties.length === 0) {
      return batteryList.filter(
        (value) =>
          value.batteryPercentage >= 50 &&
          value.cycleCount <= 500 &&
          (value.batteryAge == null || value.batteryAge == undefined || value.batteryAge <= 30)
      );
    }
    
    return batteryList.filter(value => {
      let shouldInclude = true;
      
      if (properties.includes('batteryPercentage')) {
        shouldInclude = shouldInclude && value.batteryPercentage >= 50;
      }
      
      if (properties.includes('cycleCount')) {
        shouldInclude = shouldInclude && value.cycleCount <= 500;
      }
      
      if (properties.includes('batteryAge')) {
        shouldInclude = shouldInclude && (value.batteryAge === null || value.batteryAge === undefined || value.batteryAge <= 30);
      }
      
      return shouldInclude;
    });
  }
);
export const totalCyclesCount = createSelector([data], (avgBatHp) =>
  avgBatHp.reduce((accumulator, currentValue) => {
    return currentValue.getIn(['cycleCount'], 0) >= 300 && currentValue.getIn(['cycleCount'], 0) <= 500
      ? (accumulator += 1)
      : (accumulator += 0);
  }, 0)
);
export const totalMonthsCount = createSelector([data], (avgBatHp) =>
  avgBatHp.reduce((accumulator, currentValue) => {
    return currentValue.getIn(['batteryAge'], 0) >= 24 && currentValue.getIn(['batteryAge'], 0) <= 30
      ? (accumulator += 1)
      : (accumulator += 0);
  }, 0)
);
export const totalHealthCount = createSelector([data], (avgBatHp) =>
  avgBatHp.reduce((accumulator, currentValue) => {
    return currentValue.getIn(['batteryPercentage'], 0) >= 50 && currentValue.getIn(['batteryPercentage'], 0) <= 75
      ? (accumulator += 1)
      : (accumulator += 0);
  }, 0)
);

export const isSubscribed = (state) => state.user?.subscription?.features.includes('batteries.replace.soon');

export default createStructuredSelector({
  batteryListCount,
  alertTag,
  previousMonth,
  statusCode,
  timeStamp,
  loading,
  totalCyclesCount,
  totalMonthsCount,
  totalHealthCount,
  batteryAbove,
  batteriesProperties,
  isSubscribed,
});
